import { a as getMarkers, b as getHydrationData, c as getComponentMap, d as _createForOfIteratorHelper, r as readMarker, f as getComponent, h as getProps } from '../../dist/utils-4b9185c7.esm.js';
export { b as getHydrationData } from '../../dist/utils-4b9185c7.esm.js';
import createCache from '@emotion/cache';
import { CacheProvider, ThemeProvider } from '@emotion/react';
import React from 'react';
import ReactDOM from 'react-dom';
import '@babel/runtime/helpers/toConsumableArray';

var cache = createCache({
  key: 'ni'
});

function withThemeProvider(Component) {
  return function (props) {
    if (!(props !== null && props !== void 0 && props.theme)) {
      return /*#__PURE__*/React.createElement(Component, props);
    }

    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: props.theme
    }, /*#__PURE__*/React.createElement(Component, props));
  };
}
/* global document */


function hydrate(components, options) {
  var _ref = options || {},
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? document : _ref$container,
      withWrapper = _ref.withWrapper,
      theme = _ref.theme;

  var markers = getMarkers(container);
  var data = getHydrationData();
  var componentMap = getComponentMap(components);

  var _iterator = _createForOfIteratorHelper(markers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var marker = _step.value;

      var _readMarker = readMarker(marker),
          id = _readMarker.id,
          el = _readMarker.el;

      var Component = getComponent(componentMap, data, id);

      if (Component) {
        var _props = getProps(data, id);

        if (theme) {
          _props.theme = theme;
        }

        var WrappedComponent = withWrapper ? withWrapper(Component) : Component;
        WrappedComponent = withThemeProvider(WrappedComponent);
        ReactDOM.hydrate( /*#__PURE__*/React.createElement(CacheProvider, {
          value: cache
        }, /*#__PURE__*/React.createElement(WrappedComponent, _props)), el);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

export { hydrate as default };
